
export default function SectionSubNavScroll () {

  const setInitialOffset = () => {  
    if (window.innerWidth > 700){
      return document.querySelector('.desktop-nav').offsetHeight;
    } else {
      return document.querySelector('.mobile-nav').offsetHeight;
    }
  }

  const setDeviceNavHeight = () => {  
    if (window.innerWidth > 700){
      return `${document.querySelector('.desktop-nav.backscroll--visible').offsetHeight}px`;
    } else {
      return `${document.querySelector('.mobile-nav.backscroll--visible').offsetHeight}px`;
    }
  }
  
  const initialOffset = setInitialOffset();
  const sectionSubNav = document.querySelector('.secondary-nav');
  const sectionLabel = document.querySelector('.secondary-nav__label');
  const sectionNavItems = document.querySelectorAll(".secondary-nav__item");
  const pageSections = document.querySelectorAll(".secondary-nav__section");
  const secondaryNavToggleClass = 'secondary-nav__item--active';
  const mobileNavToggleHeader = document.getElementsByClassName('secondary-nav__header')[0];
  const mobileNavWrapper = document.getElementsByClassName('secondary-nav__wrapper')[0];
  const mobileNavToggleClass = 'secondary-nav__wrapper--open';

  const viewportHeight = window.visualViewport.height/2;
  let previousScrollPosition = 0;

  const isScrollingUp = () => {
    let scrollingUp = false;
    let scrollPosition = window.pageYOffset;
    if (scrollPosition < previousScrollPosition) {
      scrollingUp = true;
    }
    previousScrollPosition = scrollPosition;
    return scrollingUp;
  };


  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        sectionNavItems.forEach(navItem => {
          navItem.addEventListener('click', function handleClick(event) {
            mobileNavWrapper.classList.remove(mobileNavToggleClass);
          });

          navItem.classList.remove(secondaryNavToggleClass);

          if (navItem.getAttribute('href') == `#${entry.target.id}` ){
            navItem.classList.add(secondaryNavToggleClass);
            sectionLabel.textContent = navItem.innerText;
          }
        });
      }
    })
  }, {rootMargin: "-100% 0px 0px 0px"});


  let lastScrollPosition = 0,
  tick = false;  

  const fn = {
    init: function () {

      window.addEventListener('scroll', function(e) {
        if (!tick) {
          window.requestAnimationFrame(function() {
            lastScrollPosition = window.scrollY;
            if (isScrollingUp()) {
              if (lastScrollPosition > viewportHeight) {
                sectionSubNav.style.setProperty('--subnav-top-offset', setDeviceNavHeight());
              } else {
                sectionSubNav.style.setProperty('--subnav-top-offset', `-${sectionSubNav.offsetHeight}px`);
              }
            } else {
              if (lastScrollPosition > initialOffset) {
                sectionSubNav.style.setProperty('--subnav-top-offset', '0px');
              } else {
                sectionSubNav.style.setProperty('--subnav-top-offset', `-${sectionSubNav.offsetHeight}px`);
              }
            }
            tick = false;
          });
          tick = true;
        }
        });

      window.addEventListener("click", function handleClick(event){
        if (mobileNavWrapper.classList.contains(mobileNavToggleClass)) {
          if (!event.target.classList.contains('secondary-nav__header') && !event.target.classList.contains('secondary-nav__item')) {
            mobileNavWrapper.classList.toggle(mobileNavToggleClass);
          }
        }
      });

      pageSections.forEach(section => {
        observer.observe(section);
      });

      mobileNavToggleHeader.addEventListener('click', function handleClick(event) {
        mobileNavWrapper.classList.toggle(mobileNavToggleClass);
      });

      sectionLabel.textContent = sectionNavItems[0].innerText;
    }
  };

  if (sectionSubNav) {
    fn.init();   
  }    
}